import { graphql } from '../../types/swarmx/gql'

export const LockedAmountsInOTCQuery = graphql(`
  query LockedAmountsInOTC($filter: Offer_filter, $limit: Int, $skip: Int) {
    offers(where: $filter, first: $limit, skip: $skip) {
      id
      availableAmount
      maker
      offerStatus
      depositAsset {
        id
        name
        symbol
        address
        decimals
        tokenId
        assetType
        kya
        tokenStandard
        tradedVolume
      }
    }
  }
`)
